import React from "react";
class ChatBoxOrionHello extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      assistantChatBgColor: props.assistantChatBgColor,
      fontSize: props.fontSize
    }
  }

  componentDidUpdate(prev) {
    if(prev.fontSize !== this.props.fontSize)
      this.setState({fontSize: this.props.fontSize})
    if(prev.assistantChatBgColor !== this.props.assistantChatBgColor)
      this.setState({assistantChatBgColor: this.props.assistantChatBgColor})
  }

  render() {
    return (
      <React.Fragment>
        <div style={{ display: 'inline-block', width: '100%' }}>
          <div style={{ display: 'flex', float: 'left' }}>
            <img className="chat-avatar" src={"/chat/Orion.svg"} style={{ height: 50, width: 50, borderRadius: 20, marginRight: 5, marginTop: 0 }} />
            <div className="paper-template" style={{ backgroundColor: this.state.assistantChatBgColor }}>
              <p style={{fontSize:this.state.fontSize}}>
                Hi! My name is Orion, and I'm here to help answer questions about your customer data.
                <br/>
                <br/>
                Here are some tips to help me give you the answers you're looking for:
              </p>
              {/* Point 1 */}
              <p style={{fontSize:this.state.fontSize}}>
                <b>1. Be specific.</b><br/>
                <div style={{paddingLeft:10}}>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      {/* <b>•</b>  */}
                    </div>
                    <div>
                      <p>
                      If you can tell me exactly what you are looking for, I'll find it faster. 
                      Please try to give me dates for data you'd like me to include in my answer.
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{paddingLeft:25}}>
                  <p style={{marginLeft:5}}><u>Examples</u></p>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      <b>•</b> 
                    </div>
                    <div>
                      Dates (January 1, 2023 to March 31, 2023)
                    </div>
                  </div>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      <b>•</b> 
                    </div>
                    <div>
                      Customer segments (e.g. Loyalty, New guests)
                    </div>
                  </div>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      <b>•</b> 
                    </div>
                    <div>
                      Geography (e.g. "stores in the Atlanta region" or "store #123")
                    </div>
                  </div>
                </div>
              </p>
              {/* Point 2 */}
              <p style={{fontSize:this.state.fontSize}}>
                <b>2. Be clear.</b><br/>
                <div style={{paddingLeft: 10}}>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      {/* <b>•</b>  */}
                    </div>
                    <div>
                      <p>
                        It's hard for me to understand terms like "recent" or "best". I'm much better if you ask me for exact metric names:
                      </p>
                    </div>
                  </div>
                  <div style={{paddingLeft:15}}>
                    <div style={{display:'flex'}}>
                      <div style={{width:15}}>
                        <b>•</b> 
                      </div>
                      <div>
                        "Average transaction value" <u>not</u> "sales"
                      </div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:15}}>
                        <b>•</b> 
                      </div>
                      <div>
                        "Top 5 locations" <u>not</u> "best locations" 
                      </div>
                    </div>
                  </div>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      {/* <b>•</b>  */}
                    </div>
                    <div>
                      <p style={{marginTop: 0, marginBottom: 5}}>
                        <br/>
                        Tell me how you want to see your answer:
                      </p>
                    </div>
                  </div>
                  <div style={{paddingLeft:15}}>
                    <div style={{display:'flex'}}>
                      <div style={{width:15}}>
                        <b>•</b> 
                      </div>
                      <div>
                        Counts, averages, percentages, or something else
                      </div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:15}}>
                        <b>•</b> 
                      </div>
                      <div>
                        Bar charts, trend lines, or both 
                      </div>
                    </div>
                    <div style={{display:'flex'}}>
                      <div style={{width:15}}>
                        <b>•</b> 
                      </div>
                      <div>
                        By day, week, month, or year 
                      </div>
                    </div>
                  </div>
                </div>
              </p>
              {/* Point 3 */}
              <p style={{fontSize: this.state.fontSize}}>
                <b>3. Be patient.</b><br/>
                <div style={{paddingLeft:10}}>
                  <div style={{display:'flex'}}>
                    <div style={{width:15}}>
                      {/* <b>•</b>  */}
                    </div>
                    <div>
                      <p>
                        Just like you, I'm learning and getting better every day. 
                        If I don't give you exactly what you want on the first try, please try again being more specific and clearer.
                        I promise I won't give up until you get what you need!
                      </p>
                    </div>
                  </div>
                </div>
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ChatBoxOrionHello;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/ChatBoxOrionHello/ChatBoxOrionHello.jsx